





















































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import InterestRateType from '@/models/Products/InterestRateType';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';
import PeriodType from '@/models/Shared/PeriodType';
import DayOfWeek from '@/models/Shared/DayOfWeek';
import Month from "@/models/Shared/Month";

@Component({ name: 'LendingInterestSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;

    async beforeMount() {
        if (this.isCreate) {
            await ProductWizardModule.getRateSources();
        }
        return ProductDetailsModule.getRateSources();
    }

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.LendingFixedTerm || this.productSubType === ProductSubType.LendingRevolvingCredit) {
                ProductWizardModule.createProductViewModel.lendingInterestSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get interestCalculationTypeOptions() {
        return ListUtils.interestCalculationTypeOptions();
    }

    get interestTypeOptions() {
        return ListUtils.interestTypeOptions();
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get dayOfWeekOptions() {
        return ListUtils.dayOfWeekOptions();
    }

    get dayOfMonthOptions() {
        return ListUtils.dayOfMonthOptions();
    }

    get monthOptions() {
        return ListUtils.monthOptions();
    }

    get interestCalculatedOnOptions() {
        return ListUtils.interestCalculatedOnOptions();
    }

    get interestPostedTypeOptions() {
        return ListUtils.interestPostedTypeOptions();
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get postedFrequencyTypeOptions() {
        return ListUtils.postedFrequencyTypeOptions();
    }

    get repaymentInterestCalculationTypeOptions() {
        return ListUtils.repaymentInterestCalculationTypeOptions();
    }

    get nonWorkingDaysOptions() {
        return ListUtils.nonWorkingDaysOptions();
    }

    get daysInYearTypeOptions() {
        return ListUtils.interestDaysInYearOptions();
    }

    get baseRateOptions() {
        return ListUtils.interestBaseRateOptions();
    }

    get rateSourceOptions() {
        if (this.isCreate) {
            return ProductWizardModule.rateSources;
        }
        return ProductDetailsModule.rateSources;
    }

    // Resets valies for rate source ID based on rate type to avoid sending bad data to API
    @Watch('productVM.lendingInterestSettings.rateType')
    async onRateTypeChanged(rateType: string) {
        if (rateType === InterestRateType.Fixed) {
            this.productVM.lendingInterestSettings.rateSourceId = undefined;
        }
    }

    // Resets valies for accruedPeriod based on periodType to avoid sending bad data to API
    @Watch('productVM.lendingInterestSettings.accruedPeriodType')
    async onAccruedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.productVM.lendingInterestSettings.accruedPeriodValue = 1;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.productVM.lendingInterestSettings.accruedPeriodValue = 1;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfWeek = DayOfWeek.Monday;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.productVM.lendingInterestSettings.accruedPeriodValue = 1;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.productVM.lendingInterestSettings.accruedPeriodValue = 1;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.lendingInterestSettings.accruedPeriodOnMonth = Month.January;
        }
    }

}
